import { Trans } from '@lingui/macro';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { TableEmpty } from 'components';
import { useSearch } from 'hooks';
import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { privateRoute } from 'routes';
import { promotionService } from 'services';
import { formatNumber } from 'utils/common';

const PromotionList = () => {
  const [dataSearch, onSearchChange] = useSearch();

  const { data } = useQuery(
    ['promotionService.fetchPromotions', dataSearch],
    () => promotionService.fetchPromotions(dataSearch),
    { keepPreviousData: true },
  );
  const { data: items = [], paginate } = data ?? {};

  return (
    <Paper>
      <div className='bg-primary-main text-white rounded-t px-3 py-2'>
        <Typography variant='h3'>
          <Trans>Promotion Setup</Trans>
        </Typography>
      </div>
      <div className='p-3'>
        <div className='flex items-center gap-3'>
          <Typography variant='h4'>
            <Trans>Promotion List</Trans>
          </Typography>
          <Link to={privateRoute.promotionSetupView.url?.({ id: 'create' })!}>
            <LoadingButton variant='contained'>
              <Trans>New</Trans>
            </LoadingButton>
          </Link>
        </div>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Trans>Created At</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Promotion Name</Trans>
                </TableCell>
                <TableCell className='text-center'>
                  <Trans>Applied Term</Trans>
                </TableCell>
                <TableCell className='text-center'>
                  <Trans>Minimum of Request Amount</Trans>
                </TableCell>
                <TableCell className='text-center'>
                  <Trans>Promotion of Discount Rate (APR)</Trans>
                </TableCell>
                <TableCell className='text-center'>
                  <Trans>Promotion of Transaction Cost</Trans>
                </TableCell>
                <TableCell className='text-center'>
                  <Trans>Number of Applied Times</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Status</Trans>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell className='text-center'>
                    {DateTime.fromISO(item.createdAt).toFormat('dd/MM/yyyy')}
                  </TableCell>
                  <TableCell>{item.promotionName}</TableCell>
                  <TableCell className='text-center'>
                    {DateTime.fromISO(item.startingDate).toFormat('dd/MM/yyyy')} -{' '}
                    {DateTime.fromISO(item.closingDate).toFormat('dd/MM/yyyy')}
                  </TableCell>
                  <TableCell className='text-center'>{formatNumber(item.minimumRequestAmount)}</TableCell>
                  <TableCell className='text-center'>{item.promotionDiscountRate} %</TableCell>
                  <TableCell className='text-center'>{formatNumber(item.promotionTransactionCost)}</TableCell>
                  <TableCell className='text-center'>{item.numberAppliedTimes}</TableCell>
                  <TableCell className='text-center'>{item.status}</TableCell>
                  <TableCell className='text-right'>
                    <Link to={privateRoute.promotionSetupView.url?.(item)!}>
                      <Button size='small' color='info'>
                        View
                      </Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
              <TableEmpty data={items} />
            </TableBody>
          </Table>
        </TableContainer>

        <div className='flex justify-center'>
          <Pagination
            page={paginate?.page ?? 1}
            count={paginate?.totalPage}
            onChange={(event, value) => onSearchChange({ page: value })}
          />
        </div>
      </div>
    </Paper>
  );
};

export default PromotionList;
